module.exports = __webpack_public_path__ + "img/7d48be28767b95040d14d78efdac9932.png";